export const GLOBAL_PLACEHOLDER = Symbol('GLOBAL_PLACEHOLDER');

export type GlobalPlaceholderToken = typeof GLOBAL_PLACEHOLDER;
